import { filter, values } from "lodash";

import { Status } from "@enums/statistic";

import type { Filters, Statistic } from "@interfaces/stats";

export const buildStatsFilters = (
  modifiedStatistic: Statistic[],
  filters?: Partial<Filters>,
) => {
  const isAnyFilterApplied = values(filters).some((filter) => filter);

  if (isAnyFilterApplied) {
    const buffer: Statistic[] = [];

    if (filters?.[Status.Delivered]) {
      const delivered = filter(
        modifiedStatistic,
        (elem) => elem.statusName === Status.Delivered,
      );

      buffer.push(...delivered);
    }

    if (filters?.[Status.AtReceiver]) {
      const atReceiver = filter(
        modifiedStatistic,
        (elem) => elem.statusName === Status.AtReceiver,
      );

      buffer.push(...atReceiver);
    }

    if (filters?.[Status.InTransit]) {
      const inTransit = filter(
        modifiedStatistic,
        (elem) => elem.statusName === Status.InTransit,
      );

      buffer.push(...inTransit);
    }

    if (filters?.[Status.ScheduledPU]) {
      const scheduledPU = filter(
        modifiedStatistic,
        (elem) => elem.statusName === Status.ScheduledPU,
      );

      buffer.push(...scheduledPU);
    }

    return buffer;
  }

  return modifiedStatistic;
};
